import React from 'react';
import { Link } from 'react-router-dom';
import RightArrow from '../SVG';

const SingleFeature = (props) => {
  const { itemClass, icon, title, description, btnText, to } = props;

  return (
    <div
      className={itemClass ? itemClass : 'it-feature-3-item mb-30 text-center'}
    >
      <div className="it-feature-3-icon">
        <span>
          <i className={icon ? icon : 'flaticon-coach'}></i>
        </span>
      </div>
      <div className="it-feature-3-content">
        <h4 className="it-feature-3-title">
          <Link to={to ? to : '/why-sanasa'}>{title ? title : 'Best Coaching'}</Link>
        </h4>
        <p>
          {description
            ? description
            : ''}
        </p>
      </div>
      <div className="it-feature-3-btn">
        <Link className="ed-btn-theme theme-2" to={to ? to : '/why-sanasa'}>
          {btnText ? btnText : 'Learn more'}
          <i>
            <RightArrow />
          </i>
        </Link>
      </div>
    </div>
  );
};
export default SingleFeature;
